import { IS_ADMIN, IS_STAFF, IS_STUDENT, IS_TUTOR } from '../store/getter-types'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      isStudent: IS_STUDENT,
      isStaff: IS_STAFF,
      isAdmin: IS_ADMIN,
      isTutor: IS_TUTOR
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Roles.js